var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-col',{attrs:{"lg":"3"},on:{"click":_vm.toggleSelected}},[_c('div',{staticClass:"layout",class:{ active: _vm.selectedCalss }},[(_vm.loading)?_c('div',{staticClass:"loader"}):_vm._e(),_c('b-img-lazy',{attrs:{"src":_vm.imgpath,"width":"200px","alt":""}})],1)]),_c('p',{staticClass:"layout_p"},[_vm._v("Layout "+_vm._s(this.number))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }